import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import reglas2 from "../assets/avatares/reglas-2.mp4";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		getGameById(game?._id).then((res) => {
			if (res.status === 200) {
				updateStats({
					...group,
					actualScenario: 1,
					time: 0,
					lastVisited: ROUTES.START_GAME,
				});
				navigate(ROUTES.START_GAME4, {
					state: { activeScenario: 1 },
				});
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<StartGameFlowLayout
			brandTheme
			sidebarTitle="Reglas Dinámica II"
			loading={loading}
			onContinue={handleNext}
			video={reglas2}
		>
			<div className="start-game-rule-block">
				<h3>Sistema de puntuación</h3>
				<p>
					Cada decisión tendrá una puntuación según su grado de adecuación. Las respuestas <span className="start-game-mark-ok">más completas, seguras y ajustadas</span> al criterio profesional sumarán más puntos.
					<br />
					Las respuestas <span className="start-game-mark-warn">menos adecuadas</span> podrán sumar menos puntos o no sumar, dependiendo del reto.
					<br />
					En algunas pruebas podréis tener una segunda oportunidad para responder. Si acertáis en el segundo intento, la puntuación será menor que si lo hacéis a la primera.
				</p>
			</div>
			<div className="start-game-rule-block">
				<p>
					Primer intento:
					<br />
					· La respuesta más adecuada son <span className="start-game-mark-ok">+10 puntos</span> pero la menos adecuada son <span className="start-game-mark-warn">-2 puntos</span>.
					<br />
					Segundo intento:
					<br />
					· La respuesta más adecuada son <span className="start-game-mark-ok">+3 puntos</span> pero si fallas en el segundo intento no te resta.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Uso de pistas</h3>
				<p>
					Todas las pruebas incluirán una pista. Podréis utilizarla si lo necesitáis, pero hacerlo tendrá un coste económico para el equipo.
					<br />
					Usar una pista: <span className="start-game-mark-warn">-3 puntos</span>.
				</p>
			</div>
		</StartGameFlowLayout>
	);
}
